import { Stack } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

import { GroupName } from '@/shared/features/groups/components/group-name/group-name';

export const GroupNameRenderer: React.FC<ICellRendererParams> = ({ data }) => (
  <Stack height="100%" justifyContent="center">
    <GroupName groupId={data.groupId} />
  </Stack>
);
